import { Injectable } from "@angular/core";

import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { HttpHeaders } from "@angular/common/http";
import { map } from "rxjs/Operators";
import { Observable, throwError } from "rxjs";
import { catchError, retry } from "rxjs/operators";
import { AppConfig } from "../../app.config";
import { OnboardingHRDetail } from "../models/OnboardingHRDetail";
// import { OnboardHREmpDetail } from 'src/Models/OnboardHREmpDetail';
import { OnboardEducationDetails } from "../models/OnboardEducationDetails";
import { OnboardHREmpDetail } from "../models/OnboardHREmpDetail";
import { OnboardPreviousEmploymentDetails } from "../models/OnboardPreviousEmploymentDetails";
import { OnboardProfessionalReferenceDetails } from "../models/OnboardProfessionalReferenceDetails";
import { OnboardVisaInformation } from "../models/OnboardVisaInformation";
import { OnboardEmergencyContactDetails } from "../models/OnboardEmergencyContactDetails";
import { OnboardOTP } from "../models/OnboardOTP";
import { DatePipe } from "@angular/common";
import { OnboardVrifications } from "../models/OnboardVrifications";
import { OnboardEmployeeDetails } from "../models/OnboardEmployeeDetails";
import { OnboardEmployeePersonalDetails } from "../models/OnboardEmployeePersonalDetails";
import { OnboardEmployeePassportVisaInfo } from "../models/OnboardEmployeePassportVisaInfo";
import { OnboardEmployeeFinanceDetails } from "../models/OnboardEmployeeFinanceDetails";
import { OnboardingExportToEmp } from "../models/onboardingExportToEmp";
import { OnboardHREmpDoc } from "../models/OnboardHREmpDoc";
import { OnboardEmployee } from "../models/OnboardEmployee";
import {
  OnboardEmpPreviousEmploymentDtls,
  OnboardPrevEmploymentInfo,
} from "../models/OnboardPrevEmploymentInfo";
import { OnboardEmpEducationInformation } from "../models/OnboardEmpEducationInformation";
import { JobSource } from "../models/JobSource";
import { JobPlatform } from "../models/JobPlatform";
import { VisaTypes } from "../models/VisaTypes";

@Injectable({
  providedIn: "root",
})
export class OnboardingService {
  constructor(private http: HttpClient, private config: AppConfig) {}
  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
    }),
  };
  private handleError(error: HttpErrorResponse) {
    return throwError(error.error);
  }

  getResumeDetails() {
    return this.http
      .get(
        this.config.apiUrl + "HREmployeeApi/GetResumeDetails",
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  getEmpList() {
    return this.http
      .get(
        this.config.apiUrl + "OnboardingApi/GetEmployeesList",
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  getEmployee(slugName: string, status: number): Observable<any> {
    return this.http
      .get(
        this.config.apiUrl +
          "OnboardingApi/GetEmployee?Slug=" +
          slugName +
          "&status=" +
          status
      )
      .pipe(catchError(this.handleError));
  }
  addEmployee(emp: OnboardingHRDetail) {
    return this.http
      .post(
        this.config.apiUrl + "OnboardingApi/AddEmployee",
        emp,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  saveEducationDetails(emp: OnboardEmpEducationInformation) {
    return this.http
      .post(
        this.config.apiUrl + "OnboardingApi/SaveEducationDetails",
        emp,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  SavePrevEmploymentDetails(emp: OnboardEmpPreviousEmploymentDtls) {
    return this.http
      .post(
        this.config.apiUrl + "OnboardingApi/SavePrevEmploymentDetails",
        emp,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  SaveReferenceDetails(emp: OnboardProfessionalReferenceDetails[]) {
    return this.http
      .post(
        this.config.apiUrl + "OnboardingApi/SaveReferenceDetails",
        emp,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  SaveVisaDetails(emp: OnboardVisaInformation[]) {
    return this.http
      .post(
        this.config.apiUrl + "OnboardingApi/SaveVisaInformation",
        emp,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  SaveEmergencyContactDetails(emp: OnboardEmergencyContactDetails[]) {
    return this.http
      .post(
        this.config.apiUrl + "OnboardingApi/SaveEmergencyContactDetails",
        emp,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  getDesignations(): Observable<any> {
    return this.http
      .get(this.config.apiUrl + "OnboardingApi/GetDesignations")
      .pipe(catchError(this.handleError));
  }
  getLocations(): Observable<any> {
    return this.http
      .get(this.config.apiUrl + "OnboardingApi/GetLocations")
      .pipe(catchError(this.handleError));
  }
  getRelation(): Observable<any> {
    return this.http
      .get(this.config.apiUrl + "OnboardingApi/GetRelation")
      .pipe(catchError(this.handleError));
  }
  validateIsUserDeleted(slugName) {
    return this.http
      .get(this.config.apiUrl + "OnboardingApi/IsUserDeleted?slug=" + slugName)
      .pipe(catchError(this.handleError));
  }

  generateOTP(empCode: any, Page: any): Observable<any> {
    return this.http
      .get(
        this.config.apiUrl +
          "HREmployeeApi/SendOTP?empCode=" +
          empCode +
          "&Page=" +
          Page
      )
      .pipe(catchError(this.handleError));
  }

  validateOTP(model: any) {
    return this.http
      .post(
        this.config.apiUrl + "HREmployeeApi/ValidateOTP",
        model,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  submitDetails(empId, status) {
    return this.http
      .post(
        this.config.apiUrl +
          "OnboardingApi/SubmitDetails?empId=" +
          empId +
          "&status=" +
          status,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  getEmployeebySlugStatus(slugName: string, status: number): Observable<any> {
    return this.http
      .get(
        this.config.apiUrl +
          "OnboardingApi/GetEmployeeDetails?Slug=" +
          slugName +
          "&status=" +
          status
      )
      .pipe(catchError(this.handleError));
  }
  GetEmployeePersonalDetails(id: number) {
    return this.http
      .get(
        this.config.apiUrl +
          "OnboardingApi/GetEmployeePersonalDetails?empId=" +
          id
      )
      .pipe(catchError(this.handleError));
  }
  GetOnboardEmpolyeeFinanceDetails(id: number) {
    return this.http
      .get(
        this.config.apiUrl +
          "OnboardingApi/GetOnboardEmpolyeeFinanceDetails?empId=" +
          id
      )
      .pipe(catchError(this.handleError));
  }
  GetOnboardEmpEducationDetails(id: number) {
    return this.http
      .get(
        this.config.apiUrl +
          "OnboardingApi/GetOnboardEmpEducationDetails?empId=" +
          id
      )
      .pipe(catchError(this.handleError));
  }
  GetOnboardPrevEmploymentDetails(id: number) {
    return this.http
      .get(
        this.config.apiUrl +
          "OnboardingApi/GetOnboardPrevEmploymentDetails?empId=" +
          id
      )
      .pipe(catchError(this.handleError));
  }
  GetPassportVisaInfo(id: number) {
    return this.http
      .get(this.config.apiUrl + "OnboardingApi/GetPassportVisaInfo?empId=" + id)
      .pipe(catchError(this.handleError));
  }
  GetOnboardEmpReferences(id: number) {
    return this.http
      .get(
        this.config.apiUrl + "OnboardingApi/GetOnboardEmpReferences?empId=" + id
      )
      .pipe(catchError(this.handleError));
  }
  GetVerificationStatus(id: number) {
    return this.http
      .get(
        this.config.apiUrl + "OnboardingApi/GetVerificationStatus?empId=" + id
      )
      .pipe(catchError(this.handleError));
  }
  saveEmpDetails(emp: OnboardEmployeeDetails) {
    return this.http
      .post(
        this.config.apiUrl + "OnboardingApi/SaveEmployeeDetails",
        emp,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  SavePersonalEmpDetails(emp: OnboardEmployeePersonalDetails) {
    return this.http
      .post(
        this.config.apiUrl + "OnboardingApi/SavePersonalEmpDetails",
        emp,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  SavePassportVisaDetails(emp: OnboardEmployeePassportVisaInfo) {
    return this.http
      .post(
        this.config.apiUrl + "OnboardingApi/SavePassportVisaDetails",
        emp,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  SaveFinanceDetails(emp: OnboardEmployeeFinanceDetails) {
    return this.http
      .post(
        this.config.apiUrl + "OnboardingApi/SaveFinanceDetails",
        emp,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  SaveVrificationStatus(emp: OnboardVrifications) {
    return this.http
      .post(
        this.config.apiUrl + "OnboardingApi/SaveVrificationStatus",
        emp,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  SaveOnboardEmpToEmployee(emp: OnboardingExportToEmp) {
    return this.http
      .post(
        this.config.apiUrl + "OnboardingApi/SaveOnBoardToEmployee",
        emp,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  DeleteFileinMultipleFiles(Id: number) {
    return this.http
      .delete(
        this.config.apiUrl + "OnboardingApi/DeleteFileinMultipleFiles?Id=" + Id,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  getEmployeebyId(empId: number) {
    return this.http
      .get(this.config.apiUrl + "OnboardingApi/GetEmployeebyId?empId=" + empId)
      .pipe(catchError(this.handleError));
  }

  getEmployeebyCodeHrDetails(empId: number) {
    return this.http
      .get(
        this.config.apiUrl +
          "HREmployeeApi/GetEmployeeHiringDetails?empCode=" +
          empId
      )
      .pipe(catchError(this.handleError));
  }

  DeleteOnboardingEmployee(empId: number) {
    return this.http
      .delete(
        this.config.apiUrl +
          "OnboardingApi/DeleteOnboardingEmployee?empId=" +
          empId,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  SaveOnboardEmployeeDetails(emp: OnboardEmployee) {
    return this.http
      .post(
        this.config.apiUrl + "OnboardingApi/SaveOnboardEmployeeDetails",
        emp,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  SaveOnboardPreviousEmploymentInfo(emp: OnboardPrevEmploymentInfo) {
    return this.http
      .post(
        this.config.apiUrl + "OnboardingApi/SaveOnboardPrevEmploymentInfo",
        emp,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  SaveOnboardEducationInfo(emp: OnboardEmpEducationInformation) {
    return this.http
      .post(
        this.config.apiUrl + "OnboardingApi/SaveOnboardEducationInfo",
        emp,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  GetOnboardAdditionalQualifications(id: number) {
    return this.http
      .get(
        this.config.apiUrl +
          "OnboardingApi/GetOnboardAdditionalQualifications?empId=" +
          id
      )
      .pipe(catchError(this.handleError));
  }
  getDepartments(): Observable<any> {
    return this.http
      .get(this.config.apiUrl + "OnboardingApi/GetDepartments")
      .pipe(catchError(this.handleError));
  }
  getCadres(): Observable<any> {
    return this.http
      .get(this.config.apiUrl + "OnboardingApi/GetCadres")
      .pipe(catchError(this.handleError));
  }
  getJobSources(): Observable<any> {
    return this.http
      .get(this.config.apiUrl + "OnboardingApi/GetProfileSource")
      .pipe(catchError(this.handleError));
  }
  getJobPlatforms(Id): Observable<any> {
    return this.http
      .get(
        this.config.apiUrl +
          "OnboardingApi/GetProfileSourceCategoryOne?Id=" +
          Id
      )
      .pipe(catchError(this.handleError));
  }
  SaveJobSource(profile: JobSource) {
    return this.http
      .post(
        this.config.apiUrl + "OnboardingApi/SaveProfileSource",
        profile,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  SaveJobPlatform(profile: JobPlatform) {
    return this.http
      .post(
        this.config.apiUrl + "OnboardingApi/SaveProfileSourceCategoryOne",
        profile,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  getVisaCountryByEmpCode(empCode: number) {
    return this.http
      .get(
        this.config.apiUrl +
          "OnboardingApi/GetVisaCountryByEmpCode?empCode=" +
          empCode
      )
      .pipe(catchError(this.handleError));
  }

  getVisaTypes() {
    return this.http
      .get(this.config.apiUrl + "OnboardingApi/GetVisaTypes")
      .pipe(catchError(this.handleError));
  }

  SaveVisaType(visa: VisaTypes) {
    return this.http
      .post(this.config.apiUrl + "OnboardingApi/SaveVisaType", visa)
      .pipe(catchError(this.handleError));
  }
}
